import { SHOW_MODAL } from '../actions/types';

const INITIAL_STATE = {
  modal: null
};

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case SHOW_MODAL:
      return { ...state, modal: action.payload };
    default:
      return state;
  }
};
